import { RootState } from 'app'

export const getQueue = (state: RootState) => state.snackbars.queue
